jQuery(document).ready(function($) {
    
    var urlParams = new URLSearchParams(window.location.search);
    var event = urlParams.get('event');
    if (event) {
      var selectElement = $('select[name="dynamic-dropdown"]');
      if (selectElement.length) {
        selectElement.find('option').each(function() {
          if ($(this).val() == event) {
            $(this).prop('selected', true);
          }
        });
        selectElement.on('change', function() {
          $(this).val(event); // Value ko wapas set karna
        });
      }
    }
    

	$(".details-popup-toggle").click(function() {
         $(this).toggleClass("on");
        $(".show-now-menus").slideToggle();
    });

    $(window).click(function(e) {
      if (!$(e.target).closest('.details-popup-toggle, .show-now-menus').length) {
        $(".details-popup-toggle").removeClass("on");
        $(".show-now-menus").slideUp();
      }
    });

    $('.owl-carousel-detail-show').owlCarousel({
      loop: true,
      margin: -2,
      nav: true,
      dots: false,
      navText: [
          "<i class='fa fa-caret-left'></i>",
          "<i class='fa fa-caret-right'></i>"
      ],
      autoplayHoverPause: true,
      startPosition: 'URLHash', 
      responsive: {
          0: {
              items: 1
          },
          600: {
              items: 3
          },
          1000: {
              items: 4
          }
      }
    });

    var hash = window.location.hash.substring(1); 
    if (hash) {
        var $carousel = $('.owl-carousel-detail-show');
        $carousel.owlCarousel('to', $('.item[data-hash="' + hash + '"]').index(), 100);
    }

    $('.active-month').click(function(e) {
      e.preventDefault();
      var hash = $(this).closest('.item').data('hash');
      if (hash) {
          window.location.hash = hash;
      }

      var month = $(this).data('month');
      var pageNo = 1;
      var cat_id = $('.menu-tb.active').data("cat_id");

      $(".active-month.active").removeClass("active");
      $(this).addClass("active");
      $('.owl-carousel-detail-show .active-month[data-month="' + month + '"]').addClass('active');
      $('.show-now-menus .active-month[data-month="' + month + '"]').addClass('active');


      $("#page_no").val(1);
      $.ajax({
        url: '/wp/wp-admin/admin-ajax.php',
        type: 'POST',
        data: {
            action: 'filter_event',
            month: month,
            cat_id: cat_id,
            pageNo: pageNo
        },
        success: function(response) {
            $('.events').html(response);
        }
      });
    });

    $('.menu-tb').click(function(e) {
        
        e.preventDefault();
         var pageNo = 1;
        $(".menu-tb.active").removeClass("active");
        $(this).addClass("active");
        var cat_id = $(this).data("cat_id");
        var month = $('.active-month.active').data("month");
        
       jQuery("#page_no").val(1);
        
        $.ajax({
            url: '/wp/wp-admin/admin-ajax.php',
            type: 'POST',
            data: {
                action: 'filter_event',
                month: month,
                cat_id: cat_id,
                pageNo: pageNo,
            },
            success: function(response) {
                $('.events').html(response);
            }
        });
    });
});




document.addEventListener("DOMContentLoaded", function() {
    var startDateInput = document.getElementById("start_date");
    if (startDateInput) {
        var startDate = startDateInput.value;
        var countDownDate = new Date(startDate).getTime();

        var x = setInterval(function() {
            var now = new Date().getTime();
            var distance = countDownDate - now;

            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // Padding function
            function pad(n) {
                return n < 10 ? '0' + n : n;
            }

            document.getElementById("demo").innerHTML =
                pad(days) + ":" + pad(hours) + ":" + pad(minutes) + ":" + pad(seconds);

            if (distance < 0) {
                clearInterval(x);
                document.getElementById("demo").innerHTML = "EXPIRED";
            }
        }, 1000);
    }
});
